import React from "react";
import Header from "../common/header";
import ITstaffingHead from "../layout/staffing/itstaffing-head";
import ITstaffingContent from "../layout/staffing/itstaffing1";
import Footer from "../common/footer";


function ITstaffing() {
    return (
        <div>
            <Header/>
            <br/>
            <ITstaffingHead/>
            <br/>
            <ITstaffingContent/>
            <br/>
            <Footer/>
        </div>
    );
};

export default ITstaffing;